module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-4.08c62163.png";